import {
    UserBonusListResponse,
    UserBonusView
} from "../http/protocol";
import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";


export class UserBonusService extends AbstractAdminEntityService<UserBonusView, UserBonusListResponse> {
    constructor(http : HttpService) {
        super("/user/bonus", http)
    }

    cancelUserBonus(userId:number, bonusId:number) {
        return this.http.post(this.entityPath + "/cancel/"+userId+"/"+bonusId, {});
    }
}


